import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
`;

export const ProductArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 60%;
`;

export const ProductImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const ProductTitle = styled.p`
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`;

export const ProductDescription = styled.span`
  color: #000;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.014px;
  padding-right: 16px;
`;

export const EanArea = styled.div`
  width: 40%;
`;

export const NoImage = styled.div`
  width: 80px;
  min-width: 80px;
  height: 80px;
  background: #33333330;
  border-radius: 8px;
`;

export const InputLine = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 20px;
`;

export const InputStyled = styled.input`
  width: 70%;
  height: 44px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};

  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
  }
`;
